(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-timer"] && !Shopify.designMode) return;
  try {
    
  class CountdownTimerBar extends HTMLElement {
      constructor() {
          super();
      }

      init() {
          this.schemaTime = this.getAttribute('schema-time');

          this.timer = this.querySelector(".timer")
          this.countdown = new Date(this.schemaTime).getTime();
          this.second = 1000;
          this.minute = this.second * 60;
          this.hour = this.minute * 60;
          this.day = this.hour * 24;

          this.timerInterval = null;
          this.startTimer();

          setTimeout(() => this.timer.style.visibility = "visible", 1000)
      }

      padWithLeadingZero = (number) => {
          if (number < 10) {
              return '0' + number;
          } else {
              return number;
          }
      };

      isDateInPast(date) {
          const now = new Date();
          return date < now;
      }


      startTimer() {
          //Have quick check to see if Date input in the countdown class variable is in the past
          //Helper function

          const timerElem = this.timer
          this.timerInterval = setInterval(() => {
              const now = new Date().getTime();
              const distance = this.countdown - now;

              const dayCalc = Math.floor(distance / this.day);
              const hourCalc = Math.floor((distance % this.day) / this.hour);
              const minuteCalc = Math.floor((distance % this.hour) / this.minute);
              const secondCalc = Math.floor((distance % this.minute) / this.second);

              timerElem.querySelector('.js-timer-days').textContent = this.padWithLeadingZero(dayCalc);
              timerElem.querySelector('.js-timer-hours').textContent = this.padWithLeadingZero(hourCalc);
              timerElem.querySelector('.js-timer-minutes').textContent = this.padWithLeadingZero(minuteCalc);
              timerElem.querySelector('.js-timer-seconds').textContent = this.padWithLeadingZero(secondCalc);
          }, this.second);
      }

      disconnectedCallback() {
          clearInterval(this.timerInterval);
      }

      connectedCallback(){
          this.init();
          console.log("countdown timer was added to the page")

          const timerFlexContainer = window.document.querySelector(".timer-flex-container")
          const timerElem = this.timer

          const pastDate = this.isDateInPast(this.countdown)
          if(pastDate){
              timerFlexContainer.remove()
              this.remove()
          }
          window.setTimeout(() => {
              timerFlexContainer.classList.remove("hide-element")
          }, 2000);
      }

      disconnectedCallback(){
          console.log("The Timer date has passed so the timer was removed")
      }
  }

  customElements.define('countdown-timer-bar', CountdownTimerBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-footer-3"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('strive-footer-folds')) {
  customElements.define('strive-footer-folds', class extends HTMLElement {
    connectedCallback() {
      this.media = window.matchMedia('(max-width: 749px)');
      this.sync = () => this.querySelectorAll('details').forEach(item => { item.open = !this.media.matches; });
      this.click = event => { if (!this.media.matches && event.target.closest('summary')) event.preventDefault(); };
      this.media.addEventListener('change', this.sync);
      this.addEventListener('click', this.click);
      this.sync();
    }
    disconnectedCallback() {
      this.media.removeEventListener('change', this.sync);
      this.removeEventListener('click', this.click);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strive-announcement"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('strive-announcement')) {
  customElements.define('strive-announcement', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      queueMicrotask(() => { if (this.isConnected && this.abort) this.init(); });
    }
    init() {
      const signal = this.abort.signal;
      this.items = [...this.querySelectorAll('.sa-message')];
      this.index = 0;
      this.hovered = false;
      this.focused = false;
      this.selected = false;
      this.visible = true;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.addEventListener('pointerenter', e => { if(e.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, { signal });
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, { signal });
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, { signal });
      this.addEventListener('focusout', e => { if(!this.contains(e.relatedTarget)) { this.focused = false; this.schedule(); } }, { signal });
      document.addEventListener('visibilitychange', () => this.schedule(), { signal });
      this.motion.addEventListener('change', () => this.schedule(), { signal });
      document.addEventListener('shopify:block:select', e => {
        const i = this.items.findIndex(item => item.dataset.block === e.detail.blockId);
        if(i >= 0) { this.selected = true; this.go(i); }
      }, { signal });
      document.addEventListener('shopify:block:deselect', e => {
        if(this.items.some(item => item.dataset.block === e.detail.blockId)) { this.selected = false; this.schedule(); }
      }, { signal });
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); });
      this.observer.observe(this);
      this.go(0);
    }
    go(index) {
      if(!this.items.length) return;
      this.index = index % this.items.length;
      this.items.forEach((item, i) => {
        const active = i === this.index;
        item.classList.toggle('is-active', active);
        item.inert = !active;
        if(active) item.removeAttribute('aria-hidden');
        else item.setAttribute('aria-hidden', 'true');
      });
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if(!this.items || this.items.length < 2 || this.dataset.auto !== 'true' || this.motion.matches || this.hovered || this.focused || this.selected || !this.visible || document.hidden) return;
      this.timer = setTimeout(() => this.go(this.index + 1), Number(this.dataset.delay) || 6000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      if(this.abort) this.abort.abort();
      if(this.observer) this.observer.disconnect();
      this.abort = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strive-cyber-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('strive-cyber-bar')) {
  customElements.define('strive-cyber-bar', class extends HTMLElement {
    connectedCallback() {
      const raw = this.dataset.deadline;
      this.timerEl = this.querySelector('.scb__timer');
      if (!raw || !this.timerEl) return;
      this.end = Date.parse(raw);
      if (Number.isNaN(this.end)) return;
      this.nums = {};
      this.querySelectorAll('[data-unit]').forEach(el => { this.nums[el.dataset.unit] = el; });
      this.timerEl.hidden = false;
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }
    tick() {
      const left = Math.max(0, this.end - Date.now());
      const s = Math.floor(left / 1000);
      const pad = n => String(n).padStart(2, '0');
      this.nums.d.textContent = pad(Math.floor(s / 86400));
      this.nums.h.textContent = pad(Math.floor(s % 86400 / 3600));
      this.nums.m.textContent = pad(Math.floor(s % 3600 / 60));
      this.nums.s.textContent = pad(s % 60);
      if (left === 0) {
        clearInterval(this.interval);
        if (this.dataset.hideOnEnd === 'true' && !(window.Shopify && window.Shopify.designMode)) this.hidden = true;
        else this.timerEl.hidden = true;
      }
    }
    disconnectedCallback() { clearInterval(this.interval); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strive-cyber-heading"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('strive-cyber-heading')) {
  customElements.define('strive-cyber-heading', class extends HTMLElement {
    connectedCallback() {
      const mapEl = this.querySelector('[data-sch-map]');
      this.buttons = [...this.querySelectorAll('button[data-filter]')];
      if (!mapEl || !this.buttons.length) return;
      try { this.map = JSON.parse(mapEl.textContent); } catch (e) { return; }
      this.empty = this.querySelector('.sch__empty');
      this.current = 'all';
      this.buttons.forEach(btn => btn.addEventListener('click', () => this.select(btn.dataset.filter, true)));

      const fromHash = (location.hash.match(/^#c=([\w-]+)/) || [])[1];
      if (fromHash && this.buttons.some(b => b.dataset.filter === fromHash)) this.select(fromHash, false);

      // Re-apply when the grid loads more products (infinite scroll) or re-renders.
      this.observer = new MutationObserver(() => this.apply());
      const target = document.getElementById('ProductGridContainer') || document.body;
      this.observer.observe(target, { childList: true, subtree: true });
    }
    select(key, updateHash) {
      this.current = key;
      this.buttons.forEach(b => {
        const on = b.dataset.filter === key;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on);
      });
      if (updateHash) {
        const url = location.pathname + location.search + (key === 'all' ? '' : '#c=' + key);
        history.replaceState(null, '', url);
      }
      this.apply();
    }
    apply() {
      const items = document.querySelectorAll('#product-grid > li');
      let visible = 0;
      items.forEach(li => {
        const link = li.querySelector('a[href*="/products/"]');
        const handle = link ? (link.getAttribute('href').match(/\/products\/([^/?#]+)/) || [])[1] : null;
        const show = this.current === 'all' || (handle && (this.map[handle] || []).includes(this.current));
        li.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      if (this.empty) this.empty.hidden = visible > 0 || !items.length;
    }
    disconnectedCallback() { if (this.observer) this.observer.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strive-hero-pro"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('strive-hero-pro')) {
  customElements.define('strive-hero-pro', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      queueMicrotask(() => { if (this.isConnected && this.controller) this.init(); });
    }
    init() {
      const signal = this.controller.signal;
      this.slides = [...this.querySelectorAll('.sh-slide')];
      this.dots = [...this.querySelectorAll('[data-go]')];
      this.toggle = this.querySelector('[data-toggle]');
      this.mobile = matchMedia('(max-width: 749px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      this.userPaused = this.reduced.matches;
      this.hovered = false;
      this.focused = false;
      this.inView = true;
      this.editorPaused = false;
      this.addEventListener('click', event => {
        const slideLink = event.target.closest('.sh-slide--link');
        if (slideLink && this.ignoreSlideClick) {
          event.preventDefault();
          this.ignoreSlideClick = false;
          return;
        }
        const control = event.target.closest('button');
        if (!control || !this.contains(control)) return;
        if (control.hasAttribute('data-prev')) this.go(this.index - 1);
        if (control.hasAttribute('data-next')) this.go(this.index + 1);
        if (control.hasAttribute('data-go')) this.go(Number(control.dataset.go));
        if (control.hasAttribute('data-toggle')) {
          this.userPaused = !this.userPaused;
          this.sync();
        }
      }, { signal });
      this.addEventListener('keydown', event => {
        if (this.slides.length < 2 || /INPUT|TEXTAREA|SELECT/.test(event.target.tagName)) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, { signal });
      this.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = true;
        this.schedule();
      }, { signal });
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, { signal });
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, { signal });
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); }
      }, { signal });
      this.addEventListener('pointerdown', event => {
        const interactive = event.target.closest('a,button');
        const isSlideLink = interactive && interactive.classList.contains('sh-slide--link');
        if (event.pointerType === 'touch' && (!interactive || isSlideLink)) this.touch = { x: event.clientX, y: event.clientY };
      }, { signal, passive: true });
      this.addEventListener('pointercancel', () => { this.touch = null; }, { signal });
      this.addEventListener('pointerup', event => {
        if (!this.touch) return;
        const dx = event.clientX - this.touch.x;
        const dy = event.clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          this.ignoreSlideClick = true;
          clearTimeout(this.slideClickTimer);
          this.slideClickTimer = setTimeout(() => { this.ignoreSlideClick = false; }, 400);
          this.go(this.index + (dx < 0 ? 1 : -1));
        }
      }, { signal, passive: true });
      this.mobile.addEventListener('change', () => {
        this.slides.forEach(slide => {
          slide.querySelectorAll('video').forEach(video => video.pause());
          slide.querySelector('.sh-video-slot').replaceChildren();
        });
        this.sync();
      }, { signal });
      this.reduced.addEventListener('change', () => {
        this.userPaused = this.reduced.matches;
        this.sync();
      }, { signal });
      document.addEventListener('visibilitychange', () => this.sync(), { signal });
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) { this.editorPaused = true; this.go(index); }
      }, { signal });
      document.addEventListener('shopify:block:deselect', event => {
        if (this.slides.some(slide => slide.dataset.blockId === event.detail.blockId)) {
          this.editorPaused = false;
          this.sync();
        }
      }, { signal });
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.sync();
      }, { threshold: 0 });
      this.observer.observe(this);
      this.classList.add('is-ready');
      this.go(0);
    }
    go(index) {
      if (!this.slides.length) return;
      const previous = this.slides[this.index];
      const focusWasInSlide = previous && previous.contains(document.activeElement);
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.inert = !active;
        if (active) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
      this.dots.forEach((dot, i) => {
        if (i === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (focusWasInSlide && previous !== this.slides[this.index]) {
        const target = this.slides[this.index].querySelector('a') || this.querySelector('[data-next]') || this.dots[this.index] || this.toggle;
        if (target && !target.hidden) target.focus({ preventScroll: true });
        else { this.tabIndex = -1; this.focus({ preventScroll: true }); }
      }
      this.sync();
    }
    sync() {
      if (!this.slides) return;
      const active = this.slides[this.index];
      const variant = this.mobile.matches ? 'mobile' : 'desktop';
      const template = active && active.querySelector(`template[data-video="${variant}"]`);
      const moving = !this.userPaused && this.inView && !document.hidden;
      this.slides.forEach(slide => {
        if (slide !== active || !moving) slide.querySelectorAll('video').forEach(video => video.pause());
      });
      if (template && moving) {
        const slot = active.querySelector('.sh-video-slot');
        if (!slot.firstElementChild) {
          slot.append(template.content.cloneNode(true));
          const video = slot.querySelector('video');
          video.muted = true;
          video.playsInline = true;
          video.addEventListener('playing', () => {
            video.classList.add('is-playing');
            if (this.userPaused || !this.inView || document.hidden || active !== this.slides[this.index]) video.pause();
          }, { signal: this.controller.signal });
          video.addEventListener('error', () => video.classList.remove('is-playing'), { signal: this.controller.signal });
        }
        const video = slot.querySelector('video');
        if (video && video.paused) {
          const result = video.play();
          if (result) result.catch(() => {
            if (active === this.slides[this.index] && this.inView && !document.hidden && !this.userPaused) {
              this.userPaused = true;
              this.updateToggle();
              this.schedule();
            }
          });
        }
      }

      this.updateToggle();
      this.schedule();
    }
    updateToggle() {
      if (!this.toggle) return;
      this.toggle.setAttribute('aria-label', this.userPaused ? this.dataset.play : this.dataset.pause);
      this.toggle.firstElementChild.textContent = this.userPaused ? '▶' : 'Ⅱ';
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.slides || this.slides.length < 2 || this.dataset.autoplay !== 'true' || this.userPaused || this.hovered || this.focused || !this.inView || document.hidden || this.editorPaused) return;
      this.timer = setTimeout(() => this.go(this.index + 1), Number(this.dataset.interval) || 7000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      clearTimeout(this.slideClickTimer);
      if (this.observer) this.observer.disconnect();
      if (this.controller) this.controller.abort();
      this.querySelectorAll('video').forEach(video => video.pause());
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
